import styled from "styled-components";
import { Input as InputBase } from "../List/components/FilterByName/style";

export const Input = styled(InputBase)`
  height: 24px;
  padding: 4px 4px 3px;
  border: solid 0.3px #697482;
  min-height: auto;
`;
